import { Tags } from '../../base/api/types';

type TagInput = {
  is_challenge?: boolean;
  is_featured?: boolean;
  is_inspiration?: boolean;
};

export function createTagString(tags: TagInput): string | null {
  const result: string[] = [];

  if (tags.is_challenge) result.push('challenge');
  if (tags.is_featured) result.push('featured');
  if (tags.is_inspiration) result.push('inspiration');

  return result.length > 0 ? result.join(' | ') : null;
}

export const extractValues = (arr?: Tags): string[] | undefined => {
  return Array.isArray(arr) && arr.length > 0 ? arr.map((item) => item.value) : undefined;
};

export const extractFirstValue = (arr?: Tags): string | undefined => {
  return Array.isArray(arr) && arr.length > 0 ? arr[0].value : undefined;
};
